import type { FaireProductEntity } from "../../entity_types/product";

export const p_fgev7zxr4h: FaireProductEntity = {
  token: "p_fgev7zxr4h",
  type: "product",
  name: "Hawai'i Landscapes - Set of 5 Cards",
  brandName: "Misha Hawaii Home",
  imageUrl:
    "https://cdn.faire.com/fastly/228c3b5f832c75bbfab1a0f23c77308864ee5186ae227262ed7866022dd0e3d2.png",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0efd8d14c6e70e35b3b74a6f586e973c92e860ee35a42470daec0ac1ad25ea00.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
